/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

import { Reducer, AnyAction } from "redux";

import { FETCH_USER, CLASSIC_LOGIN, UPDATE_USER } from "../actions/types";

export type UserState =
  | boolean
  | {
      name: string | null;
      [props: string]: any;
    };

const userReducerDefaultState: UserState = {
  name: null,
  email: null,
};

export const userReducer: Reducer<UserState, AnyAction> = (
  state = userReducerDefaultState,
  action: AnyAction,
) => {
  switch (action.type) {
    case FETCH_USER:
      return action.payload || false;

    // There are three auth situations:
    // 1. Logged on - there's payload data, return it
    // 2. Not logged on - payload is "", we return false  ("" || false will return false)
    // 3. Unknow - when userReducer has no idea if it's logged on,
    //    the default case returns the default state : null

    case CLASSIC_LOGIN:
      // do nothing
      return state;

    case UPDATE_USER:
      return typeof state !== "boolean"
        ? { ...state, ...action.payload }
        : state;

    default:
      return state;
  }
};

// Keep in sync with orion\src\middlewares\auth.js
const itOpAccessW2 = 0x0770; // IT operation right (level 2, dev)
const cmOpAccessW1 = 0x0300; // content manager for owned content
const adminAccess1 = 0x1770; // admin right

export const isAdmin = (tc: number) => (tc & adminAccess1 ? true : false);
export const isCtMan = (tc: number) => (tc & cmOpAccessW1 ? true : false);
export const isStaff = (tc: number) => (tc & itOpAccessW2 ? true : false);
